var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 122,
    viewBox: "0 0 130 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6251 86.9363C58.1283 88.9234 57.6315 90.4138 57.6315 92.4009C57.1347 96.3752 56.6379 99.8527 56.6379 103.827C56.6379 104.821 56.6379 105.814 56.6379 106.808C52.6636 108.795 49.6829 109.292 47.199 107.801C45.7087 106.808 44.7151 105.317 43.7215 102.337C42.728 98.8591 42.728 93.3945 43.2248 87.4331C44.2183 75.0135 48.6894 62.0971 48.6894 61.1035C52.6637 70.5424 56.1411 78.9877 58.6251 86.9363Z",
    fill: "url(#paint0_linear_670_86532)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.312 11.4263C91.8984 21.362 81.9627 32.2913 73.5174 48.6851C72.0271 45.7044 70.5367 43.2205 69.0464 40.2398C67.0592 37.2591 65.0721 33.7816 63.085 30.8009C66.0657 25.8331 68.0528 23.3491 71.0335 19.3749C71.0335 18.8781 71.5303 18.8781 71.5303 18.3813C75.5046 13.9102 79.4788 9.93597 83.9499 6.45848C87.9242 2.98099 91.8984 0.993854 94.8791 0.49707C94.8791 0.49707 94.8791 0.49707 95.3759 0.49707H95.8727C95.8727 0.49707 95.8727 0.49707 96.3695 0.49707H96.8663C96.8663 0.49707 96.8663 0.49707 97.3631 0.49707C98.3566 0.49707 99.847 0.49707 100.841 0.993854C103.324 2.48421 104.815 5.9617 105.312 11.4263Z",
    fill: "url(#paint1_linear_670_86532)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.759 76.008C102.83 96.8729 89.9132 113.267 79.4807 119.725C79.4807 119.725 78.9839 120.222 78.4871 120.222H77.9904C77.9904 120.222 77.9903 120.222 77.4936 120.222C77.4936 120.222 77.4936 120.222 76.9968 120.222H76.5H76.0032C75.5064 120.222 75.5064 120.222 75.0096 120.719C75.0096 120.719 74.5129 120.719 74.0161 121.215H73.5193H73.0225H72.5257H72.0289C71.5322 121.215 71.5322 121.215 71.0354 121.215C70.5386 121.215 70.5386 121.215 70.0418 121.215C69.545 121.215 69.545 121.215 69.0482 121.215C68.5514 121.215 68.5515 121.215 68.0547 121.215C67.5579 121.215 67.0611 121.215 66.5643 121.215H66.0675C66.0675 121.215 66.0675 121.215 65.5707 121.215C65.074 121.215 65.074 121.215 64.5772 121.215H64.0804H63.5836H63.0868H62.59H62.0933H61.5965H61.0997H60.6029C60.1061 121.215 60.1061 121.215 59.6093 120.719C59.1126 120.719 58.6158 120.222 58.6158 120.222C58.6158 120.222 58.6158 120.222 58.119 120.222C52.1576 117.241 49.1769 113.267 47.6865 110.286C50.1704 110.783 52.1576 110.783 54.1447 110.783C54.6415 110.783 55.1383 110.286 56.1319 110.286C57.1254 109.789 58.119 109.789 59.1126 108.796H59.6093C60.6029 108.299 62.0933 107.305 63.0868 106.809C63.5836 106.312 64.0804 105.815 65.074 105.318C66.0675 104.821 67.0611 103.828 68.0547 102.834C68.5515 102.338 69.0482 101.841 69.545 101.344C73.5193 97.3697 77.4936 92.4018 81.9646 86.4404C83.455 83.9565 85.4421 81.4726 86.9325 78.9887C89.9132 74.0208 92.8939 69.053 95.3778 63.5884C104.32 45.7041 109.288 28.3167 110.281 15.8971C110.281 13.91 110.281 12.4196 110.281 10.9293C110.281 10.4325 110.281 10.4325 110.281 9.93568C110.281 9.93568 110.281 8.94211 109.785 7.45176V6.95498C109.785 6.45819 109.288 5.96141 109.288 4.96784C106.804 3.97427 105.81 1.98714 104.32 0C107.797 0.496784 112.765 1.49035 117.733 4.47106C118.23 4.47106 118.23 4.96784 118.727 4.96784C128.166 11.9228 128.662 19.3746 128.662 19.3746C130.649 31.2974 125.185 53.1559 113.759 76.008Z",
    fill: "url(#paint2_linear_670_86532)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6282 109.79C57.6282 109.79 56.6346 110.287 54.6475 111.28C55.641 110.784 56.6346 110.287 57.6282 109.79Z",
    fill: "url(#paint3_linear_670_86532)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4659 77.9948C80.9756 80.4787 79.4852 82.9626 77.4981 85.4466C73.5238 91.408 69.5495 95.879 65.5753 99.8533C65.0785 100.35 64.5817 100.847 64.0849 101.344C64.0849 100.35 64.0849 99.8533 63.5881 98.8597C63.0913 96.8726 63.0913 94.3887 62.5946 91.9047C62.0978 88.924 61.1042 85.9433 60.1106 82.4659C56.1364 70.0462 50.6717 57.6266 43.7168 46.2006C42.7232 44.2135 41.2328 42.2263 39.7425 40.2392C37.2586 35.2714 34.2779 30.8003 30.3036 26.826C27.8197 23.3485 24.3422 19.8711 20.8647 16.8904C18.8776 15.4 16.8904 13.9096 14.9033 12.4193C11.9226 10.9289 6.45796 8.44503 2.98047 13.4129V12.9161C5.46439 9.43859 8.44509 6.95467 11.9226 4.96754C14.4065 3.47719 17.3872 1.98683 20.3679 0.993266C28.8132 -2.98101 45.7039 11.4257 61.1042 33.781C63.0913 36.2649 65.0785 39.7424 67.0656 42.7231C68.556 45.7038 70.5431 48.1877 71.5367 51.1685C72.5302 52.6588 73.027 54.6459 74.0206 56.1363C77.9949 64.0848 80.4788 71.5366 82.4659 77.9948Z",
    fill: "url(#paint4_linear_670_86532)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7041 115.749C30.8006 104.323 19.3746 90.4133 10.9292 73.5226C4.96784 61.5998 0.993568 48.1866 0 34.7735C0 30.7992 -4.81173e-07 27.3217 0.496784 23.3474C0.496784 23.3474 0.496784 22.3539 0.993568 20.8635C0.993568 20.3667 0.993568 20.3667 1.49035 19.87C4.96784 11.4246 11.426 14.4053 14.9035 16.3925C13.4132 28.3153 17.8842 48.6834 28.3167 69.5484C31.2974 75.013 33.2845 78.9873 36.2652 82.9615C37.2588 84.4519 38.7492 85.9422 39.7427 87.9294L40.2395 88.4262C38.7492 99.3554 40.7363 108.794 45.7041 115.749Z",
    fill: "url(#paint5_linear_670_86532)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_670_86532",
    x1: 88.2309,
    y1: -4.55395,
    x2: 38.6191,
    y2: 117.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#312783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_670_86532",
    x1: 93.6943,
    y1: -2.33658,
    x2: 44.0825,
    y2: 120.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#312783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_670_86532",
    x1: 60.9541,
    y1: 120.488,
    x2: 127.004,
    y2: 7.51635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_670_86532",
    x1: 58.1374,
    y1: 108.733,
    x2: 55.2724,
    y2: 111.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000343525,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_670_86532",
    x1: 75.8845,
    y1: 84.9572,
    x2: -0.32662,
    y2: -18.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_670_86532",
    x1: -12.6899,
    y1: 5.95007,
    x2: 66.8085,
    y2: 128.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e9a753b9631cca646e9580b680093d04.svg";
export { ForwardRef as ReactComponent };